module.exports = __webpack_public_path__ + "img/character-dwarf.17589ea0.png";